<pl-container>
  <div class="pl-profile flex flex-col h-full gap-4 py-4">
    <h1 class="self-center">
      {{ 'profile.title' | translate }}
    </h1>
    <p class="text-lg">
      {{ 'profile.intro_text_profile' | translate }}
    </p>
    <mat-tab-group
      [mat-stretch-tabs]="false"
      mat-align-tabs="start"
      [animationDuration]="'0ms'"
      [selectedIndex]="selectedTabIndex()"
      (selectedIndexChange)="onTabChange($event)"
    >
      @for (tab of tabs(); track tab.tabLabelUrl) {
        <mat-tab [labelClass]="'pl-tab'" [label]="tab.tabLabel">
          <div class="py-4 h-full">
            <ng-container *ngComponentOutlet="tab.component" />
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</pl-container>
